angular.module('app.api').factory('PreferencesApi', [
  'api',
  function PreferencesApi(api) {
    const preferencesApi = {
      getLocations: async () => {
        return api.get('locations?regions=true')
      },
      getCategoryById: async id => {
        return api.get(`categories/${id}`)
      },
      getLanguages: async () => {
        const languages = await api.get('languages')

        const sorted = languages.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        )

        const withSorted = _.extend(languages, {data: sorted})

        return withSorted
      },
      getContractTypes: async () => {
        return api.get('contract-types')
      },
      getOccupationsByProfession: async profession => {
        return api.get(
          `occupations${profession ? `?profession=${profession}` : ``}`
        )
      },
    }
    return preferencesApi
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/api/preferences.api.js